export const USER_DETAILS_KEY = "SEARCH_USER_DETAILS";

// export const REACT_APP_API_AUTHORIZATION_KEY =
//   process.env.REACT_APP_API_AUTHORIZATION_KEY;
export const USER_REDUCER_ACTIONS = {
  INTIALIZE_USER: "INTIALIZE_USER",
  FETCH_USER: "FETCH_USER",
  DELETE_USER: "DELETE_USER",
  UPDATE_USER: "UPDATE_USER",
};

// export const CHAT_URL = "https://3.83.115.54:5000/";
export const CHAT_URL = "http://3.21.92.123/";
// export const CHAT_URL = "https://devsearch-chat.herokuapp.com/";
// export const CHAT_URL = "http://127.0.0.1:5001/";

export const URLS = {
  ADD_INSTITUTE: "/admin/addinstitute",
  EDIT_INSTITUTE: "/admin/modifyinstitute",
};

export const REPITITON_OPTIONS = [
  "Daily",
  "Weekdays",
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const WEEKDAY_OPTIONS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
];

export const REACH_OUT_OPTIONS = [
  "Facebook",
  "LinkedIn",
  "Twitter",
  "Dribble",
];

export const LANGUAGE_OPTIONS = [
  "English",
  "Spanish",
  "German",
  "French",
  "Danish",
  "Hindi",
  "Chinese",
  "Japanese",
  "Korean",
  "Nepali",
];

export const DUMMY_INSTRUCTORS = [
  {
    name: "Instructor 1",
    email: "Email 1",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
  {
    name: "Instructor 2",
    email: "Email 2",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
  {
    name: "Instructor 3",
    email: "Email 3",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
  {
    name: "Instructor 4",
    email: "Email 4",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
  {
    name: "Instructor 5",
    email: "Email 5",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
  {
    name: "Instructor 6",
    email: "Email 6",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
  {
    name: "Instructor 7",
    email: "Email 7",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
  {
    name: "Instructor 8",
    email: "Email 8",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
  {
    name: "Instructor 9",
    email: "Email 9",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
  {
    name: "Instructor 10",
    email: "Email 10",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
  {
    name: "Instructor 11",
    email: "Email 11",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
  {
    name: "Instructor 12",
    email: "Email 12",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
  {
    name: "Instructor 13",
    email: "Email 13",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
  {
    name: "Instructor 14",
    email: "Email 14",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
  {
    name: "Instructor 15",
    email: "Email 15",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "English, Spanish",
  },
  {
    name: "Instructor 16",
    email: "Email 16",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
  {
    name: "Instructor 16",
    email: "Email 16",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "Danish",
  },
  {
    name: "Instructor 17",
    email: "Email 17",
    linkedInProfile: "https://www.linkedin.com/feed/",
    waysToReachOut: "",
    spokenLanguages: "",
  },
];

export const DUMMY_INSTITUTES = [
  {
    name: "Institute 1",
    address: "Address 1",
    web_link: "Link 1",
    description: "Description 1",
    linkedIn_profile: "",
    ways_to_reach_out: "",
    imageUrl: "https://picsum.photos/200",
  },
  {
    name: "Institute 2",
    address: "Address 2",
    web_link: "Link 2",
    description: "Description 2",
    linkedIn_profile: "",
    ways_to_reach_out: "",
    imageUrl: "https://picsum.photos/200",
  },
  {
    name: "Institute 3",
    address: "Address 3",
    web_link: "Link 3",
    description: "Description 3",
    linkedIn_profile: "",
    ways_to_reach_out: "",
    imageUrl: "https://picsum.photos/200",
  },
  {
    name: "Institute 4",
    address: "Address 4",
    web_link: "Link 4",
    description: "Description 4",
    linkedIn_profile: "",
    ways_to_reach_out: "",
    imageUrl: "https://picsum.photos/200",
  },
  {
    name: "Institute 5",
    address: "Address 5",
    web_link: "Link 5",
    description: "Description 5",
    linkedIn_profile: "",
    ways_to_reach_out: "",
    imageUrl: "https://picsum.photos/200",
  },
  {
    name: "Institute 6",
    address: "Address 6",
    web_link: "Link 6",
    description: "Description 6",
    linkedIn_profile: "",
    ways_to_reach_out: "",
    imageUrl: "https://picsum.photos/200",
  },
  {
    name: "Institute 7",
    address: "Address 7",
    web_link: "Link 7",
    description: "Description 7",
    linkedIn_profile: "",
    ways_to_reach_out: "",
    imageUrl: "https://picsum.photos/200",
  },
  {
    name: "Institute 8",
    address: "Address 8",
    web_link: "Link 8",
    description: "Description 8",
    linkedIn_profile: "",
    ways_to_reach_out: "",
    imageUrl: "",
  },
  {
    name: "Institute 9",
    address: "Address 9",
    web_link: "Link 9",
    description: "Description 9",
    linkedIn_profile: "",
    ways_to_reach_out: "",
    imageUrl: "",
  },
  {
    name: "Institute 10",
    address: "Address 10",
    web_link: "Link 10",
    description: "Description 10",
    linkedIn_profile: "",
    ways_to_reach_out: "",
    imageUrl: "",
  },
  {
    name: "Institute 11",
    address: "Address 11",
    web_link: "Link 11",
    description: "Description 11",
    linkedIn_profile: "",
    ways_to_reach_out: "",
    imageUrl: "",
  },
  {
    name: "Institute 12",
    address: "Address 12",
    web_link: "Link 12",
    description: "Description 12",
    linkedIn_profile: "",
    ways_to_reach_out: "",
    imageUrl: "",
  },
  {
    name: "Institute 13",
    address: "Address 13",
    web_link: "Link 13",
    description: "Description 13",
    linkedIn_profile: "",
    ways_to_reach_out: "",
    imageUrl: "",
  },
  {
    name: "Institute 14",
    address: "Address 14",
    web_link: "Link 14",
    description: "Description 14",
    linkedIn_profile: "",
    ways_to_reach_out: "",
    imageUrl: "",
  },
];
